// Order Redemption
export const PRINTED_CODE_ENTERED = 'Printed Code Clicked'
export const ERROR_MISSING_REQUEST_CODE = 'Error Missing Request Code'
// Track Cart
export const CART_ITEM_ADDED = 'Product Added'
export const CART_ITEM_REMOVED = 'Product Removed'
export const CART_ITEM_EDIT = 'Order Updated'
export const CART_VIEWED = 'Cart Viewed'
// Track Catalog
export const CATALOG_ITEM_SELECTED = 'Product Clicked'
export const INSTANT_CHECKOUT_CLICKED = 'Instant Checkout Clicked'
export const ADD_TO_CART_CLICKED = 'Add to Cart Clicked'
export const TRACK_CATALOG_SEARCH = 'Catalog Searched'
// Track Checkout
export const CHECKOUT_ITEM_EDIT = 'Edit Item Button Clicked'
export const CHECKOUT_STEP_VIEWED = 'Checkout Step Viewed'
export const CHECKOUT_STEP_COMPLETED = 'Checkout Step Completed'
export const CHECKOUT_STARTED = 'Checkout Started'
// Track Help Center
export const HELP_CENTER_CLICKED = 'Help Center Clicked'
export const FAQ_CLICKED = 'FAQ Clicked'
// Track Order Confirmation
export const ORDER_CONFIRMATION_CALL_US = 'Call Us Clicked'
export const ORDER_CONFIRMATION_EMAIL_US = 'Email Us Clicked'
// Track Order History
export const ORDER_HISTORY_BUTTON_CLICKED = 'Order History Button Clicked'
export const RESEND_DIALOG_OPENED = 'Resend Dialog Opened'
export const RESEND_BUTTON_CLICKED = 'Resend Button Clicked'
// Track Review And Complete
export const ORDER_COMPLETED = 'Order Completed'
